import { render, staticRenderFns } from "./StudentProfileDetails.vue?vue&type=template&id=961fe318&"
import script from "./StudentProfileDetails.vue?vue&type=script&lang=js&"
export * from "./StudentProfileDetails.vue?vue&type=script&lang=js&"
import style0 from "./StudentProfileDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports